import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/layouts/account.vue").then(m => m.default || m)),
  checkout: defineAsyncComponent(() => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/layouts/default.vue").then(m => m.default || m))
}